// index.tsx
import React, { useState, useEffect } from 'react';
import {
  week,
  getMonthData,
  btnStyle,
  getDayOfYear,
  nowYear,
  nowMonth,
  Iprops,
  DateRet,
} from './util';
import styles from './index.module.scss';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import moment from 'moment';
import { deepCopy } from '../../util';
interface Props {
  // onRefresh?(date: DateRet): void;
}
export default function InitDatePicker({
  handleClick,
  handleMouseEnter,
  onPanelChange,
  dateCellRender,
  currentMonth,
  currentYear,
  dataType,
  onRefresh,
  taskCount,
  taskList
}: Iprops,) {
  // 记录上一个月
  const [lastMonth, setLastMonth] = useState<number>(0),
    // 当前年份
    // [currentYear, setCurrentYear] = useState<number>(nowYear),
    // 当前月份
    [currentMonth1, setCurrentMonth] = useState<number>(nowMonth),
    // 日历展示数据
    [monthList, setMonthList] = useState<any[]>([]),
    //按周分月历
    [monthWeekList, setMonthWeekList] = useState<any[]>([]),

    // 鼠标移过日期
    [currentMouseHoverDate, setCurrentMouseHoverDate] = useState<any>(null);

  useEffect(() => {
    setMonthList(getMonthData(currentYear, currentMonth));
  }, [currentYear, currentMonth]);
  useEffect(() => {

    if (monthList.length > 0) {
      let arr: any = []
      let _monthList: any = deepCopy(monthList)
      for (let i = 0; i < 7; i++) {
        arr.push(_monthList.slice(i * 7, i * 7 + 7))
      }
      setMonthWeekList(arr)
    }
  }, [monthList,]);
  /**
   *  触发事件 点击事件｜鼠标移入事件｜面板改变事件
   * @param param 日期
   * @param type 类型 1、点击 2、鼠标移入
   */
  // function onClick({ year, month, showDate: date }: any, type: number) {
  //   const data = { year, month, date };
  //   if (type === 1) {
  //     if (lastMonth !== 0 && lastMonth !== month) {
  //       // 面板改变时触发
  //       handlePanelChange(data)
  //     }
  //     setLastMonth(month);
  //     handleClick && handleClick(data);
  //   } else {
  //     handleMouseEnter && handleMouseEnter(data);
  //   }
  // }
  function onClick({ year, month, date }: any, type: number, item?: any) {
    const data = { year, month, date };
    console.log(item)
    //点击周末是需判断是否加班，不加班则不显示
    // if (!item || !item.isWeekend) {
    onRefresh && onRefresh(data);
    // }
  }
  // 下一月
  // function handleNextMonth() {
  //   const month = currentMonth + 1;
  //   if (month >= 13) {
  //     const year = currentYear + 1;
  //     setCurrentYear(year);
  //     setCurrentMonth(1);
  //     // 面板改变时触发
  //     const data = {
  //       year,
  //       month: 1,
  //       date: 1,
  //     };
  //     handlePanelChange(data);
  //   } else {
  //     setCurrentMonth(month);
  //     // 面板改变时触发
  //     const data = {
  //       year: currentYear,
  //       month,
  //       date: 1,
  //     };
  //     handlePanelChange(data);
  //   }
  // }

  /**
   * 查看上一个月
   */
  // function handlePrevMonth() {
  //   const month = currentMonth - 1;
  //   if (month <= 0) {
  //     const year = currentYear - 1;
  //     setCurrentYear(year);
  //     setCurrentMonth(12);
  //     // 面板改变时触发
  //     const data = {
  //       year,
  //       month: 12,
  //       date: 1,
  //     };
  //     handlePanelChange(data);
  //   } else {
  //     setCurrentMonth(month);
  //     // 面板改变时触发
  //     const data = {
  //       year: currentYear,
  //       month,
  //       date: 1,
  //     };
  //     handlePanelChange(data);
  //   }
  // }

  /**
   * 面板修改
   */
  function handlePanelChange(data: DateRet) {
    onPanelChange && onPanelChange(data);
  }

  // 当前时间
  // function handleSetTimeNow() {
  //   setCurrentYear(currentYear);
  //   setCurrentMonth(currentMonth);
  // }

  return (
    <>
      {(dataType === 'season' || dataType === 'month') &&
        <div className={(dataType === 'season') ? styles.season : styles.month}>
          <div data-flex='main:left cross:center' className={styles.header}>
            {currentMonth}{(dataType === 'season') ? '季度' : '月'}
          </div>
          <div data-flex='main:center cross:center' onClick={() => onClick({
            year: currentYear,
            month: (dataType === 'season') ? currentMonth * 3 : currentMonth,
            date: 1,
          }, 1)} className={`${styles.content}`}>
            {taskCount}
          </div>
        </div>
      }
      {(dataType === 'day' || dataType === 'week') &&

        <div className={styles.calenderContainer}>
          <div data-flex='main:left cross:center' className={styles.header}>
            {currentMonth}月
          </div>
          <div className={styles.main}>
            <div className={styles.week}>
              {week.map((it) => {
                return (
                  <div key={it} className={styles.weekCell}>
                    {it}
                  </div>
                );
              })}
            </div>
            {dataType === 'day' && <div className={styles.date} data-flex='main:justify cross:center flex-wrap' >{
              monthList.map((date, i) => {
                let index: any = moment(`${date.year}-${date.month}-${date.showDate}`).format('YYYY-MM-DD')
                return (
                  <div
                    className={`${styles.dateCell}`}
                    key={i}
                    onClick={() => onClick(date, 1, taskList[getDayOfYear(index)])}
                    // onMouseEnter={() => onClick(date, 0)}
                    style={{
                      background: currentMonth === date.month ? '#fff' : '#fff',
                    }}
                  >
                    <div
                      className={`${styles.dateCellHeader} ${(currentMonth !== date.month) ? styles.disabled : ''} `}
                      style={{
                        color:
                          currentMonth === date.month
                            ? 'rgba(0,0,0,.85)'
                            : 'rgba(0,0,0,.3)',
                      }}
                    >
                      <div className={`${styles.dateCellBox} ${(taskList[getDayOfYear(index)]?.taskCount > 0 && currentMonth === date.month) ? styles.tags : ''}`}>
                        {(taskList[getDayOfYear(index)]?.taskCount > 0 && currentMonth === date.month) && <div className={styles.taskCount}>{taskList[getDayOfYear(index)]?.taskCount}</div>}
                        <div className={styles.showDate}>{date.showDate}</div>
                      </div>
                    </div>
                    <div className={styles.dateCellMain}>
                      {dateCellRender && dateCellRender(date)}
                    </div>
                  </div>
                );
              })}
            </div>}
            {dataType === 'week' && <div className={`${styles.date} ${styles.weekTask}`} >

              {monthWeekList.map((item, index) => {
                let weekIndex: any
                if (item.length > 0) {
                  weekIndex = moment(moment(`${item[0].year}-${item[0].month}-${item[0].showDate}`).format('YYYY-MM-DD')).week()

                }
                //刨除第一周为52的情况
                if (index == 0 && weekIndex == 52) {
                  weekIndex = 0
                }
                return (
                  <div data-flex='main:justify cross:center flex-wrap' className='pos-r' onClick={() => onClick({
                    year: item[0].year,
                    month: item[0].month,
                    date: item[1].showDate,
                  }, 1)}>
                    {
                      item.map((date: any, i: any) => {
                        return (<>
                          <div
                            className={`${styles.dateCell}`}
                            key={i}
                            style={{
                              background: currentMonth === date.month ? '#fff' : '#fff',
                            }}
                          >
                            <div
                              className={styles.dateCellHeader}
                              style={{
                                color:
                                  currentMonth === date.month
                                    ? 'rgba(0,0,0,.85)'
                                    : 'rgba(0,0,0,.3)',
                              }}
                            >
                              <div className={`${styles.dateCellBox}`}>
                                <div className={styles.showDate}>{date.showDate}</div>
                              </div>
                            </div>
                            <div className={styles.dateCellMain}>
                              {dateCellRender && dateCellRender(date)}
                            </div>
                          </div>
                        </>)
                      })
                    }
                    {
                      (taskList[weekIndex]?.taskCount > 0 && item.findIndex((date: any, i: any) => currentMonth === date.month) >= 0) && <div
                        className={`${styles.weekTaskCount} weekTaskCount`}>
                        {taskList[weekIndex]?.taskCount}
                      </div>
                    }
                  </div>
                );
              })
              }
            </div>
            }
          </div>
        </div>}

    </>
  );
}

